import { ComponentAPI } from '@philips-emr/tws-core';

class HyperMediaAPI extends ComponentAPI {

  getResources(): any {
    return this.state.resources;
  }

  setResources(resources: object): void{
    this.setState({ resources });
  }

  getType(): any {
    return this.state.type;
  }
  setType(type: object): void {
    this.setState({ type });
  }

}

export default HyperMediaAPI;
